const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20webtoon%20cover%20art%20style%20featuring%20a%20romantic%20couple%20in%20elegant%20modern%20clothing%20standing%20back%20to%20back%2C%20soft%20pink%20and%20cream%20gradient%20background%2C%20delicate%20floral%20frame%20elements%2C%20dreamy%20atmospheric%20lighting%2C%20professional%20manhwa%20cover%20quality&width=400&height=500&seq=manga-card-01&orientation=portrait',
    title: '社内恋爱法则',
    tag: '恋爱',
    status: '连载中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20style%20featuring%20a%20handsome%20cultivator%20in%20flowing%20white%20robes%20with%20glowing%20sword%2C%20dramatic%20golden%20energy%20effects%2C%20ancient%20Chinese%20ink%20painting%20style%20background%20with%20mountains%20and%20clouds%2C%20epic%20fantasy%20cover%20aesthetic&width=400&height=500&seq=manga-card-02&orientation=portrait',
    title: '重生之都市仙尊',
    tag: '热血',
    status: '连载中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20art%20style%20featuring%20a%20determined%20teenage%20hero%20with%20spiky%20hair%20in%20school%20uniform%2C%20action%20pose%20with%20glowing%20fist%2C%20dynamic%20speed%20lines%20background%2C%20bold%20vibrant%20colors%20typical%20of%20shonen%20jump%20covers%2C%20clean%20sharp%20linework&width=400&height=500&seq=manga-card-03&orientation=portrait',
    title: '咒术学院',
    tag: '战斗',
    status: '连载中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20style%20featuring%20a%20mysterious%20beautiful%20woman%20in%20a%20dark%20alley%20with%20dramatic%20lighting%2C%20thriller%20mystery%20atmosphere%2C%20rain%20slicked%20streets%20reflecting%20neon%20lights%2C%20suspenseful%20cinematic%20cover%20with%20cool%20teal%20and%20crimson%20color%20scheme&width=400&height=500&seq=manga-card-04&orientation=portrait',
    title: '暗夜追踪者',
    tag: '悬疑',
    status: '连载中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20style%20featuring%20a%20whimsical%20fantasy%20world%20with%20floating%20islands%20and%20magical%20creatures%2C%20young%20adventurer%20with%20staff%20looking%20toward%20horizon%2C%20vibrant%20colorful%20sky%20with%20multiple%20moons%2C%20dreamy%20fantasy%20cover%20aesthetic%20with%20sparkles&width=400&height=500&seq=manga-card-05&orientation=portrait',
    title: '苍穹幻想录',
    tag: '奇幻',
    status: '连载中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20art%20style%20featuring%20a%20cute%20school%20romance%20scene%20with%20cherry%20blossoms%20falling%2C%20two%20high%20school%20students%20sharing%20a%20shy%20glance%20under%20a%20tree%2C%20soft%20pink%20and%20blue%20pastel%20color%20palette%2C%20heartwarming%20slice%20of%20life%20cover%20aesthetic&width=400&height=500&seq=manga-card-06&orientation=portrait',
    title: '樱花树下的约定',
    tag: '校园',
    status: '已完结',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门漫画</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            当前最受欢迎的漫画作品，漫友都在看
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {cards.map((item, idx) => (
            <div
              key={idx}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-background-100 border border-background-200/70 group-hover:border-primary-200 transition-all">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`汗汗漫画 ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded text-xs font-medium bg-background-950/60 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-2 right-2">
                  <span className="px-2 py-0.5 rounded text-xs font-medium bg-primary-500 text-background-50 whitespace-nowrap">
                    {item.status}
                  </span>
                </div>
              </div>
              <h3 className="font-heading text-sm text-foreground-950 text-center truncate">{item.title}</h3>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#index"
            onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="inline-flex items-center text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer whitespace-nowrap transition-colors"
          >
            浏览更多漫画
            <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>
      </div>
    </section>
  );
}